import React, { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Divider, Form } from 'antd';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
import RegisterCard from './RegisterCard/RegisterCard';
import { useLocation } from 'react-router-dom';
import PolicyAndMemberIdModal from '../forget/PolicyAndMemberIdModal';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { StyledTitle } from 'components/StyledTitle';
import { useContext } from 'react';
import { RegistrationFlowContext } from 'contexts/registration';
import ProgressSteps from './components/ProgressSteps';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { osName, osVersion } from 'react-device-detect';
import { useKeycloakReady } from 'hooks';
import './Confirm.less';
import { localStorageService } from 'utils/LocalStorageService';

import { Spinner } from 'components';
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;
const ResponsiveContainer = styled.div`
  z-index: 100;
  margin-top: 120px;
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
type LifeCardPropList = {
  color?: string;
  arrow?: true;
  stateCode?: string;
  policynumber?: string;
  title?: string;
  name?: string;
  policyTitle?: string;
  alertsType?: string;
  alertsCode?: string;
  dueDate?: string;
  productCategory?: string;
  productCategoryUrl?: string;
  productCategoryEn?: string;
  productCategoryTC?: string;
  companyCode?: string;
  productName?: string;
  productNameTc?: string;
  policyStatusCode?: string;
  policyStatus?: string;
  policyStatusTc?: string;
  colour?: string;
  alertStateCode?: string;
  alertState?: string;
  alertStateTc?: string;
  policyNumber?: string;
  insuredName?: string;
  premiumDueDate?: string;
  salesUnitCode?: string;
  effectiveStart?: string;
  effectiveEnd?: string;
  memberId?: string;
}[];
interface LocationState {
  lifeCardData: LifeCardPropList;
  life: boolean;
  username: string;
  password: string;
}

function RegistrationConfirmPage() {
  const location = useLocation();
  const { keycloak } = useKeycloak();
  const { life, lifeCardData, username, password } = (location.state as LocationState) ?? {};
  const { t, i18n } = useTranslation();
  const { state, selectFlag } = useContext(RegistrationFlowContext);
  console.log('state.selfDefinedLoginId', state.selfDefinedLoginId);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const { tokenParsed } = useKeycloakReady();
  const from: string = tokenParsed?.ebClientKey != '' ? '/home' : '/LIHome';
  const [form] = Form.useForm();
  const [isloading, setIsloading] = useState(false);

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [form, i18n.language]);

  const gotoLifeorEB = async () => {
    console.log(username, password);

    // await loginWithRetry(username, password, 0);
    setIsloading(false);
    if (life) {
      // 跳转到 eb
      navigate('/ProfileConnectEb');
    } else {
      // 跳转到 life
      navigate('/ProfileConnectLife');
    }
  };
  const startUsing = async () => {
    await loginWithRetry(username, password, 0);
    // 使用 replace 代替 reset，来模拟重置历史记录
    localStorage.setItem('username', username);
    navigate(from, { replace: true });
  };
  const loginWithRetry = useCallback(
    (username: string, password: string, maxAttempts: number) => {
      return new Promise<void>((resolve, reject) => {
        setIsloading(true);
        const keycloakLogin = async (attempt = 1) => {
          try {
            await keycloak.login({
              username,
              password,
              device: osName,
              deviceVersion: osVersion,
              deviceId: localStorageService.get('deviceId'),
              loginMethod: 'RE_LOGIN',
              loginPlatform: 'WEB',
            });
            resolve();
          } catch (error: unknown) {
            const errorMessage = error instanceof Error ? error.message : undefined;
            // console.log('loginWithRetry()->error from keycloak.login():', errorMessage);
            if (attempt >= maxAttempts) {
              console.log('error.message');
              reject({ view: true });
            } else {
              if (errorMessage && !errorMessage.includes('auth error')) {
                // reject(error);
                setTimeout(() => keycloakLogin(attempt + 1), 500);
              } else {
                setTimeout(() => keycloakLogin(attempt + 1), 500);
              }
            }
          }
        };

        keycloakLogin();
      });
    },
    [keycloak],
  );
  const closeModel = () => {
    setIsModalVisible(false);
  };
  const [showErrorView, setShowErrorView] = useState(false);
  useEffect(() => {
    try {
      const login = async () => {
        setIsloading(true);
        // await loginWithRetry(username, password, 3);
        loginWithRetry(username, password, 3)
          .then(() => {
            setIsloading(false);
          })
          .catch((error) => {
            // setShowErrorView((error as { view: boolean }).view);
            if ((error as { view: boolean }).view) {
              navigate('/LifeNotFound', {
                state: {
                  defaultTo: '/login',
                  defaultLabel: t('common.backToLogin'),
                },
              });
            }
          });
      };
      if (username && password) {
        login();
      }
    } catch (error) {
      if ((error as { view: boolean }).view) {
        setShowErrorView((error as { view: boolean }).view);
      }
    }
  }, [username, password, loginWithRetry, navigate, t]);
  // const isEnglish = i18n.language === 'en';
  // const RegisterCardData: LifeCardPropList = [];
  if (showErrorView) {
    return <>11</>;
  }
  return (
    <ResponsiveContainer className="confirm_wrapper">
      {isloading && (
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      )}
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <ProgressSteps activeStepIndex={2} />
        <div
          style={{
            // backgroundColor: 'pink',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="title" style={{ textAlign: 'center' }}>
            <StyledTitle
              style={{ fontFamily: 'Roboto400', whiteSpace: 'pre-line' }}
              level={5}
              type="secondary"
              margin="0 0 24px 0"
              fontSize="26px"
              color="#20252B"
            >
              {t('registration.congratulations')}
            </StyledTitle>
          </div>
          <StyledTitle
            level={5}
            style={{ textAlign: 'center', fontFamily: 'Roboto400', display: 'block' }}
            type="secondary"
            margin="0 0 24px 0"
            fontSize="17px"
            color="#6F7072"
          >
            {life ? t('registration.added') : t('life.register.added')}
          </StyledTitle>

          <Wrapper
            className="card_wrapper"
            style={{
              // backgroundColor: 'pink',
              width: '812px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 0,
              border: 0,
              padding: 0,
            }}
          >
            <StyledTitle style={{ fontFamily: 'Roboto400' }} className="titlq" level={4}>
              {life ? t('registration.title1') : t('registration.employeeBenefits')}
            </StyledTitle>
            <Divider style={{ width: '812px' }} />
            <RegisterCard data={lifeCardData} isLife={life ? true : false} />
          </Wrapper>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              // backgroundColor: 'pink',
            }}
            className="form_btn"
          >
            {selectFlag !== 'C' && (
              <StyledTitle
                level={5}
                className="btn_tip"
                type="secondary"
                margin="0 0 24px 0"
                style={{ fontFamily: 'Roboto400', fontSize: '26px', color: '#20252B' }}
              >
                {life ? t('registration.question2') : t('life.register.askMsg')}
              </StyledTitle>
            )}
            {selectFlag !== 'C' && (
              <Button
                className="btn"
                block
                type="default"
                size="large"
                // onClick={() => navigate('/register/LifeRegistrationLanding')}
                onClick={gotoLifeorEB}
                // loading={isloading}
                style={{
                  color: '#C21B17',
                  // backgroundColor: 'pink',
                  borderColor: '#C21B17',
                  width: '80%',
                  height: '56px',
                  fontSize: '20px',
                  fontFamily: 'Roboto500',
                }}
              >
                {life ? t('registration.addedBtn') : t('life.register.addedBtn')}
              </Button>
            )}
            <Button
              block
              className="btn"
              type="primary"
              size="large"
              style={{
                marginTop: '12px',
                // maxWidth: '100%',
                width: '80%',
                height: '56px',
                fontSize: '20px',
                fontFamily: 'Roboto500',
              }}
              // onClick={() => navigate('/ebRegist')}
              onClick={startUsing}
            >
              {life ? t('registration.useBtn') : t('life.register.useBtn')}
            </Button>
          </div>
        </div>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default RegistrationConfirmPage;
